import React from 'react';
import { journeyIntro } from '../data/site';
import { usePage } from '../context/PageContext';
import LabExperience from '../components/lab/LabExperience';
import StackMarquee from '../components/sections/home/StackMarquee';
import Results from '../components/sections/home/Results';
import Principles from '../components/sections/home/Principles';
import Approach from '../components/sections/home/Approach';
import Insights from '../components/sections/home/Insights';
import ProcessCircuit from '../components/sections/shared/ProcessCircuit';
import TextReveal from '../components/fx/TextReveal';
import Label from '../components/primitives/Label';

// "We're not just another IT service provider…" with the partner phrase set as the accent
const manifesto = journeyIntro.replace('dedicated technology partner', '*dedicated technology partner*');

/*
 * Landing page: the immersive WebGL opening (the DVS core and one world per service, see
 * components/lab/), then the proof and practice sections.
 */
const Home = () => {
  usePage(null);

  return (
    <>
      <LabExperience />
      <StackMarquee />
      <TextReveal text={manifesto} textClassName="display-md max-w-[22ch] !font-[440]">
        <Label index="01" className="mb-10">Who we are</Label>
      </TextReveal>
      <Results index="02" />
      <Principles index="03" />
      <Approach index="04" />
      <ProcessCircuit index="05" />
      <Insights index="06" />
    </>
  );
};

export default Home;
